module.exports = __webpack_public_path__ + "img/huawei-store.971aaabd.svg";